import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EmptyModule } from 'src/app/shared/components/empty/empty.module';
import { PaginatorModule } from 'src/app/shared/components/paginator/paginator.module';
import { ScrollbarModule } from 'src/app/shared/components/scrollbar/scrollbar.module';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { CustomizeFormModule } from '../customize-form/customize-form.module';
import { PipesModule } from './../../pipes/pipes.module';
import { LedPopupComponent } from './led-popup.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    CustomizeFormModule,
    PaginatorModule,
    ScrollbarModule,
    LoadingModule,
    EmptyModule,
  ],
  declarations: [LedPopupComponent],
  exports: [LedPopupComponent],
})
export class LedPopupModule {}
